/**
 * Функция для получения уникальных объектов из массива по заданному полю.
 * @param array - Массив объектов.
 * @param field - Поле, по которому определяются уникальные объекты.
 * @returns Массив уникальных объектов.
 */
export function getUniqueObjects<T, K extends keyof T>(array: T[], field: K): T[] {
  const uniqueMap = new Map<T[K], T>();

  array.forEach(item => {
    if (!uniqueMap.has(item[field])) {
      uniqueMap.set(item[field], item);
    }
  });

  return Array.from(uniqueMap.values());
}
